export default "__VITE_ASSET__3bd8774d__"